module.exports = "https://cdn.realtymogul.com/static/media/icon_diversification.6322ab36.svg";